export default () => {
    const loadSlide = (slider_data, slider, index) => {
        let content = slider.querySelector('.js-content');
        let media = slider.querySelector('.js-media');
        let video = slider.querySelector('.js-player');
        video.src = slider_data[index].dataset.url;
        video.poster = slider_data[index].dataset.url.posterUrl;
        media.style.backgroundImage = `url('${slider_data[index].dataset.posterUrl}')`;
        content.innerHTML = slider_data[index].innerHTML;      
      };
  
      const changeSlide = (slider) => {
        slider.classList.add('is-changing');
        setTimeout(() => {
          slider.classList.remove('is-changing')
        }, 600);
      }
  
      const loadSlider = () => {
        const allMediaSlider = document.querySelectorAll('.js-mediaslider');
        if (allMediaSlider) {
            allMediaSlider.forEach(slider => {

            let slider_data = slider.querySelectorAll('.js-slide-data');
            
            let playBtn = slider.querySelector('.js-playbtn');
            let content = slider.querySelector('.js-content');
            let video = slider.querySelector('.js-player');
            let prev = slider.querySelector('.js-mediaslider-prev');
            let next = slider.querySelector('.js-mediaslider-next');
            let currentIndex = +slider.dataset.index;
            let stopBtn;
    
            loadSlide(slider_data, slider, currentIndex);
    
            playBtn.addEventListener('click', () => {
              slider.classList.add('is-playing');
              content.classList.add('js-stopbtn');
              stopBtn = slider.querySelector('.js-stopbtn');
              video.play();
    
              if (stopBtn) {            
                stopBtn.addEventListener('click', () => {
                  video.load();
                  video.pause();
                  slider.classList.remove('is-playing');
                })
              }
              video.addEventListener('click', () => {
                video.load();
                video.pause();
                slider.classList.remove('is-playing');
              })
              video.addEventListener('ended', () => {
                video.load();
                video.pause();
                slider.classList.remove('is-playing');
              })
            })
    
            prev.addEventListener('click', () => {
              let newIndex;
              if (currentIndex - 1 >= 0) {
                newIndex = currentIndex - 1;
              } else {
                newIndex = slider_data.length - 1;
              }
  
              slider.dataset.index = newIndex;
              changeSlide(slider);
              loadSlider();
            })
            next.addEventListener('click', () => {
              let newIndex;
              if (currentIndex + 1 <= slider_data.length - 1 ) {
                newIndex = currentIndex + 1;
              } else {
                newIndex = 0;
              }
  
              slider.dataset.index = newIndex;
              changeSlide(slider);
              loadSlider();
            })
          });
        }
      } 
  
      loadSlider();
}